import Header from '../Header/Header';
import { Icon, CustomTable, ConfirmationPopup, SuccessModal, Pagination, Search, Loader } from '@ohif/ui';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppDispatch, RootState } from '@custom/store/store';
import { useDispatch, useSelector } from 'react-redux';
import fetchActiveMachineList from '@custom/rtk-apis/activeMachine/activeMachineList';
import { customStyle } from '@custom/Utils/utils';
import { deleteMachine } from '@custom/rtk-apis/activeMachine/deleteActiveMachine';
import { resetdeletedmachineSlice } from '@custom/store/slices/Activmachine/deleteMachineSlice';
import { useTheme } from '../../ui/src/contextProviders';

const FrontdeskMachines = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { data: machineList, loading, error, total } = useSelector((state: RootState) => state.ActiveMachinelistSliceResponse);
  const deletemachineresponce = useSelector((state: RootState) => state.deleteMachineSliceResponce);

  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [tableData, setTableData] = useState([]);
  const [pgNumber, setPgNumber] = useState(1);
  const [pgLimit, setPgLimit] = useState(30);
  const [totalPage, setTotalPage] = useState(0);
  const [searchInputValue, setSearchInputValue] = useState('');

  useEffect(() => {
    dispatch(fetchActiveMachineList({ limit: pgLimit, pageNumber: pgNumber, search: searchQuery }));
  }, [dispatch, searchQuery, pgNumber, pgLimit]);

  useEffect(() => {
    if (machineList) {
      setTableData(machineList);
      setTotalPage(total);
    }
  }, [machineList]);

  useEffect(() => {
    if (deletemachineresponce?.status === 'SUCCESS') {
      setIsSuccessModal(true);
      setTimeout(() => {
        dispatch(fetchActiveMachineList({ limit: pgLimit, pageNumber: pgNumber, search: searchQuery }));
      }, 500);
      dispatch(resetdeletedmachineSlice());
    }
  }, [deletemachineresponce, dispatch, pgLimit, pgNumber, searchQuery]);
  const onPageChangeHandler = (pg) => {
    setPgNumber(pg);
  };

  const handlePageSizeChange = (e) => {
    setPgLimit(e);
  };

  const columns = [
    { key: 'machineType', title: 'Machine Type' },
    { key: 'totalMachine', title: 'Total No. of Machines' },
    { key: 'activeMachine', title: 'Active' },
    { key: 'inactiveMachine', title: 'Inactive' },
    { key: 'actions', title: 'Action' },
  ];

  const actions = [
    {
      label: 'Edit',
      iconName: 'edit',
      onClick: (item) => {
        navigate('/addeditactivemachine', {
          state: {
            machinesData: item,
          },
        });
      },
    },
    {
      label: 'Delete',
      iconName: 'delete',
      onClick: (item) => {
        setSelectedRow(item);
        setIsPopupOpen(true);
      },
    },
  ];

  const handleConfirm = () => {
    if (selectedRow) {
      dispatch(deleteMachine(selectedRow._id));
    }
    setIsPopupOpen(false);
  };

  const handleCancel = () => {
    setIsPopupOpen(false);
  };

  const navigateToPage = () => {
    navigate('/addeditactivemachine');
  };

  const searchClick = (searchText) => {
    setSearchQuery(searchText);
    setSearchInputValue(searchText);
  };

  const isDarkMode = useTheme();
  return (
    <>
      <div className="page page__fullBody" style={
        isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
      }>
        <Header isBack={false} title="Machine Type"></Header>
        <div className="page__body">
          <div className="tableWrap">
            <div className="tableWrap__head">
              <div className="formRow formRow__3 m_0 w_100 formRow--flexEnd">
                <div className="formCol">
                  <Search text="Search by Machine Name" onSearchClick={searchClick} value={searchInputValue} setValue={setSearchInputValue}></Search>
                </div>
              </div>
              <div className="btn__group">
                <button className="btn btn__white" onClick={navigateToPage}>
                  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.63509 1.16699V12.8337M1.80176 7.00033H13.4684" stroke="#150823" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  Add New Machine Type
                </button>
              </div>
            </div>
            <div className="tableContainer">
              {loading ? <Loader isLoaderOpen={loading} /> : <CustomTable columns={columns} data={tableData} actions={actions} searchQuery={searchQuery} from="activemachine" />}
            </div>
          </div>
        </div>
        <Pagination
          onChangePage={onPageChangeHandler}
          currentPage={pgNumber}
          perPage={pgLimit}
          onChangePerPage={handlePageSizeChange}
          totalPage={totalPage}
        />
      </div>

      <ConfirmationPopup
        title={""}
        isOpen={isPopupOpen}
        message={`Are you sure you want to delete ${selectedRow?.machineType}?`}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
      <SuccessModal
        isSuccessModalOpen={isSuccessModalOpen}
        title={`Machine delete successfully.`}
        handleCloseModal={() => setIsSuccessModal(false)}
      />
    </>
  );
};

export default FrontdeskMachines;
